<template>
  <ModalDialog
    ref="dialog"
    title="Adjust Glass Size Moving Average"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-analytics"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>This manually adjusts the glass size unit moving average</NotificationBarTitle>
        <ul>
          <li>This value is updated automatically based on incoming stock via purchase orders</li>
          <li>Only manually adjust this value if issues occurred during purchase order receival</li>
        </ul>
      </NotificationBar>
      
      <FormRow label="Glass Size">
        <FormStaticLabel>{{glassSize.height}} x {{glassSize.width}}</FormStaticLabel>
      </FormRow>
      <FormRow label="Moving Average Price">
        <FormInputCurrency placeholder="Moving Average Unit Price" v-model="glassSize.unitPriceMovingAverage" field="unitPriceMovingAverage" />
      </FormRow>
      <FormRow label="Adjustment Reason">
        <FormInputTextArea ref="textEntryArea" v-model="adjustReason" placeholder="Enter reason and details for manual adjustment" field="adjustReason" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'


export default {
  name: 'GlassSizeMovingAverageDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    stock: Object,
    stockId: Number
  },
  data() {
    return {
      id: null,
      glassSize: {},
      adjustReason: '',
      dialogForm: {},
      submitting: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {

  },
  methods: {
    show(glassSize) {
      // Reset form
      this.glassSize = {
      }
      this.id = 0
      this.dialogForm = {}
      this.submitting = false

      if(glassSize != null) {
        this.glassSize = _.cloneDeep(glassSize)
        this.id = glassSize.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        unitPriceMovingAverage: this.glassSize.unitPriceMovingAverage,
        adjustReason: this.adjustReason
      }

      this.$apiService.inventoryService.adjustGlassSizeMovingAvg(this.stockId, this.id, updateData)
      .then(() => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.dialogForm = this.processFormResponse(err)
      })
    }
  }
}
</script>